export const formatNumberWithCommas = (number: number): string => {
  // Arredondar para evitar problemas de ponto flutuante
  const rounded = Math.round(number);
  const numberString = rounded.toString(); // Convert number to string
  const pattern = /(\d)(?=(\d{3})+(?!\d))/g; // Regular expression pattern
  return numberString.replace(pattern, "$1.");
};
